import { useEffect, useRef, useState, useId } from 'react'
import { Icon } from './Icon'

export const SEARCH_DELAY = 300
export function SearchField({ value, onCommit, label = 'Buscar productos', placeholder = 'Busca un producto o SKU' }: { value: string; onCommit: (value: string, explicit?: boolean) => void; label?: string; placeholder?: string }) {
  const [draft, setDraft] = useState(value)
  const input = useRef<HTMLInputElement>(null)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  const composing = useRef(false)
  const commit = useRef(onCommit)
  commit.current = onCommit
  const id = useId()
  const cancel = () => clearTimeout(timer.current)
  useEffect(() => { cancel(); setDraft(value) }, [value])
  useEffect(() => cancel, [])
  function schedule(next: string) {
    cancel()
    if (!composing.current) timer.current = setTimeout(() => commit.current(next), SEARCH_DELAY)
  }
  return <form className="search-field" role="search" noValidate onSubmit={(event) => {
    event.preventDefault()
    if (composing.current) return
    cancel(); commit.current(draft, true)
  }}>
    <label htmlFor={id} className="sr-only">{label}</label><Icon name="search" />
    <input id={id} ref={input} type="search" autoComplete="off" placeholder={placeholder} value={draft}
      onChange={(event) => { setDraft(event.target.value); schedule(event.target.value) }}
      onCompositionStart={() => { composing.current = true; cancel() }}
      onCompositionEnd={(event) => { composing.current = false; schedule(event.currentTarget.value) }}
      onKeyDown={(event) => { if (event.key === 'Enter' && (event.nativeEvent.isComposing || composing.current)) event.preventDefault() }} />
    <span className="search-clear-slot">{draft && <button type="button" aria-label="Limpiar búsqueda" title="Limpiar búsqueda" className="icon-button" onClick={() => { cancel(); setDraft(''); commit.current('', true); input.current?.focus() }}><Icon name="close" size={18} /></button>}</span>
    <button type="submit" className="search-submit">Buscar</button>
  </form>
}
